<template>
  <v-row no-gutters :class="{ 'flex-row': horizontal, 'flex-column': !horizontal }" :title="item && item.title">
    <v-col :cols="horizontal && hasDeepSelect ? 6 : 12">
      <div class="d-flex">
        <open-ledger-btn
          v-if="(showLedgerBtn && hasLedger && item && item.id) || (showBtns && item && item.id)"
          :query="{
            'ledger.account': item.id,
            'ledger.level': `level${item.level}`,
          }"
          class="mr-2"
        />
        <v-btn
          icon
          v-if="(hasLedger && item && item.id) || (showBtns && item && item.id)"
          @click="openBalanceDialog"
          class="mr-2 ml-2"
        >
          <v-img max-width="27" src="/img/icons/wallet.svg"> </v-img>
        </v-btn>
        <v-autocomplete
          :menu-props="{ bottom: true, offsetY: true }"
          class="rounded-lg"
          :items="items"
          v-model="item"
          :label="label"
          :item-text="mainSelectItemText"
          :disabled="disabled || accountDisabled"
          :multiple="multiple"
          :placeholder="placeholder"
          item-value="id"
          :return-object="true"
          v-bind="$attrs"
          clearable
        ></v-autocomplete>
      </div>
    </v-col>
    <template v-if="hasDeepSelect">
      <v-col v-for="floatAccountType in floatAccountTypes" v-if="hasFloatAccount(item, floatAccountType.groupKey)">
        <v-autocomplete
          :value="getVariable(floatAccountType.localKey)"
          @input="setVariable(floatAccountType.localKey, $event)"
          :disabled="disabled"
          :label="'*' + floatAccountType.text"
          :items="getAccountFloatAccounts(item, floatAccountType.groupKey)"
          item-text="name"
          item-value="id"
          class="rounded-lg"
          :class="{
            'mr-1': horizontal,
            'mt-1': !horizontal,
          }"
          :return-object="true"
          v-bind="$attrs"
          clearable
        />
      </v-col>
    </template>

    <v-dialog v-model="balanceDialog" max-width="500px" v-if="item && item.balance">
      <v-card>
        <v-toolbar flat class="ma-1 rounded-lg white--text" color="secondary" dark
          >مانده حساب {{ item.name }}
        </v-toolbar>
        <v-card-text class="mt-3">
          <v-row>
            <v-col cols="12">
              <v-simple-table class="text-center">
                <thead>
                  <tr>
                    <th class="text-center">بدهکار</th>
                    <th class="text-center">بستانکار</th>
                    <th class="text-center">مانده</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.balance.bed | toMoney }}</td>
                    <td>{{ item.balance.bes | toMoney }}</td>
                    <td>{{ item.balance.remain | toMoney }}</td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import accountApiMixin from "@/mixin/accountMixin";
import OpenLedgerBtn from "@/components/btns/OpenLedgerBtn.vue";

export default {
  mixins: [accountApiMixin],
  components: { OpenLedgerBtn },
  props: {
    value: {},
    floatAccount1: {},
    floatAccount2: {},
    floatAccount3: {},
    floatAccount4: {},
    label: {
      default: null,
    },
    placeholder: {
      default: null,
    },
    disabled: {
      default: false,
    },
    accountDisabled: {
      // only disables account (not floats)
      default: false,
    },
    itemText: {
      default: null,
    },
    multiple: {
      default: false,
    },
    itemsType: {
      default: "all",
      validator(value) {
        return [
          "all",
          "level0",
          "level1",
          "level2",
          "level3",
          "persons",
          "buyers",
          "sellers",
          "imprests",
          "floatAccounts",
          "floatAccountGroups",
          "p", // PERSON
          "s", // POS
          "g", // GATEWAY
          "b", // BANK
          "d", // DEPOSIT
          "i", // IMPREST
          "o", // OTHER
          "r", // PARTNER_RECEIVE
          "a", // PARTNER_PAYMENT
        ].includes(value);
      },
    },
    visitorId: {
      default: null,
    },
    childOf: {
      default: null,
    },
    deepSelect: {
      default: true,
    },
    showLedgerBtn: {
      default: true,
    },
    showBalanceBtn: {
      default: true,
    },
    showBtns: {
      default: false,
    },
    horizontal: {
      default: false,
    },
    filter: {
      default: null,
    },
  },
  data() {
    return {
      item: null,
      localFloatAccount1: undefined,
      localFloatAccount2: undefined,
      localFloatAccount3: undefined,
      localFloatAccount4: undefined,
      balanceDialog: false,
    };
  },
  computed: {
    mainSelectItemText() {
      if (this.itemText) return this.itemText;
      if (this.itemsType.includes("level")) return "title";
      return "name";
    },
    items() {
      let items = [];

      if (this.itemsType == "floatAccounts") items = this.floatAccounts;
      if (this.itemsType == "floatAccountGroups") items = this.floatAccountGroups;

      if (this.disabled) return this.accounts;

      if (items.length == 0) {
        this.accounts.forEach((item) => {
          if (this.itemsType == "all") {
            items.push(item);
          }

          if (this.itemsType.includes("level")) {
            let level = this.itemsType[this.itemsType.length - 1];
            if (item.level == level) {
              items.push(item);
            }
          }

          if (this.itemsType == "buyers") {
            if (item.buyer_or_seller == "b") {
              items.push(item);
            }
          }

          if (this.itemsType == "sellers") {
            if (item.buyer_or_seller == "s") {
              items.push(item);
            }
          }

          if (this.itemsType == "imprests") {
            let isImprest =
              this.defaultAccounts.filter((o) => o.usage == "imprest" && o.account.id == item.parent).length != 0;
            if (isImprest) {
              items.push(item);
            }
          }
          if (item.account_type == this.itemsType) {
            items.push(item);
          }
        });
      }

      if (this.childOf) {
        items = items.filter((o) => {
          if (this.itemsType.includes("floatAccounts")) {
            return o.floatAccountGroups.filter((o) => o.id == this.childOf).length == 1;
          } else {
            return o.parent == this.childOf;
          }
        });
      }

      if (this.visitorId) {
        items = items.filter((item) => {
          let path = this.paths.find((o) => o.id == item.path);
          if (path) {
            parent = this.paths.find((o) => o.id == path.parent);
            return parent.visitors.includes(this.visitorId);
          } else {
            return false;
          }
        });
      }

      if (this.filter) {
        items = items.filter(this.filter);
      }

      return items;
    },
    hasDeepSelect() {
      if (this.deepSelect == false) return false;

      let hasFloatAccountGroup = false;
      if (this.item) {
        this.floatAccountTypes.forEach((floatAccountType) => {
          const groups = this.item[floatAccountType.groupKey];
          if (groups) hasFloatAccountGroup |= groups.length != 0;
        });
      }
      return this.item && hasFloatAccountGroup;
    },
    hasLedger() {
      return ["level3", "persons", "buyers", "sellers", "imprests"].includes(this.itemsType);
    },
  },
  created() {
    this.getDefaultAccounts();
    this.getAccounts(false, () => this.setItem());
    this.getFloatAccounts(false, () => this.setItem());
    this.getFloatAccountGroups(false, () => this.setItem());
    this.visitorId && this.getPaths();

    this.setItem();
  },
  methods: {
    openBalanceDialog() {
      this.request({
        url: this.endpoint(`accounts/accounts/${this.item.id}`),
        method: "get",
        success: (data) => {
          this.item = data;
          this.balanceDialog = true;
        },
      });
    },
    setItem() {
      let emitChanges = false;
      if (this.value != this.item) {
        if (isNaN(this.value)) {
          this.item = this.value;
        } else {
          this.item = this.items.find((o) => o.id == this.value);
          this.$emit("input", this.item);
          emitChanges = true;
        }
      }

      if (!this.item) {
        this.setLocalFloatAccounts(null);
      } else {
        for (const floatAccountType of this.floatAccountTypes) {
          const key = floatAccountType.key;
          const localKey = floatAccountType.localKey;
          if (this[key] != this[localKey]) {
            if (isNaN(this[key])) {
              this[localKey] = this[key];
            } else {
              this[localKey] = this.floatAccounts.find((o) => o.id == this[key]);
              emitChanges = true;
            }
          }
        }
      }

      if (emitChanges) {
        this.emitChange();
      }
    },
    emitChange() {
      this.$emit("change", {
        account: this.item,
        floatAccount1: this.localFloatAccount1,
        floatAccount2: this.localFloatAccount2,
        floatAccount3: this.localFloatAccount3,
        floatAccount4: this.localFloatAccount4,
      });
    },
    setLocalFloatAccounts(value) {
      this.localFloatAccount1 = value;
      this.localFloatAccount2 = value;
      this.localFloatAccount3 = value;
      this.localFloatAccount4 = value;
    },
  },
  watch: {
    value() {
      this.setItem();
      this.setLocalFloatAccounts(null);
    },
    floatAccount1() {
      this.setItem();
    },
    floatAccount2() {
      this.setItem();
    },
    floatAccount3() {
      this.setItem();
    },
    floatAccount4() {
      this.setItem();
    },
    item() {
      this.$emit("input", this.item || null);
      if (this.item) {
        this.floatAccountTypes.forEach((floatAccountType) => {
          const floatAccountGroups = this.item[floatAccountType.groupKey];
          if (floatAccountGroups && floatAccountGroups.length == 0) {
            this.$emit("update:" + floatAccountType.key, null);
          }
        });
      }
      this.emitChange();
    },
    localFloatAccount1() {
      this.$emit("update:floatAccount1", this.localFloatAccount1);
      this.emitChange();
    },
    localFloatAccount2() {
      this.$emit("update:floatAccount2", this.localFloatAccount2);
      this.emitChange();
    },
    localFloatAccount3() {
      this.$emit("update:floatAccount3", this.localFloatAccount3);
      this.emitChange();
    },
    localFloatAccount4() {
      this.$emit("update:floatAccount4", this.localFloatAccount4);
      this.emitChange();
    },
    visitorId() {
      this.visitorId && this.getPaths();
    },
  },
};
</script>

<style lang="scss" scoped>
.account-select-container {
  &.horizontal {
    display: flex;
    min-width: 200px;
  }
}
</style>
